import type { ReactNode } from 'react'
import * as styles from './status-label.css'

export type StatusLabelProps = {
  description: string
  value?: string
  icon?: ReactNode
}

export const StatusLabel: React.FC<StatusLabelProps> = ({ description, value, icon }) => {
  return (
    <div className={styles.container}>
      {icon && (
        <div className={styles.iconContainer} data-testid="status-label-icon">
          {icon}
        </div>
      )}
      {value && (
        <p className={styles.value} data-testid="status-label-value">
          {value}
        </p>
      )}
      <p className={styles.description}>{description}</p>
    </div>
  )
}
